import React from "react";
import Navbar from "../features/Navbar/Navbar";
import ProductDetail from "../features/Product/Component/ProductDetails";

export default function ProductDetailPage() {
  return (
    <div>
      <Navbar></Navbar>
      <ProductDetail></ProductDetail>
    </div>
  );
}
